import { colors } from '@lmc/common/constants'

export const getIconProps = (props) => {
  const { isOverdue, signed } = props

  return signed
    ? { name: 'tick-in-circle', fill: colors.successgreen }
    : isOverdue
      ? { name: 'overdue', fill: colors.red }
      : { name: 'clock', fill: colors.yellow }
}

export const getLabelText = (props) => {
  const { isOverdue, signed } = props

  const medsLabel = signed ? 'Signed' : isOverdue ? 'Not signed' : 'Due'

  return medsLabel
}

export const getSubLabel = (props) => {
  const loggedBy = props?.loggedBy

  if (!loggedBy) return null

  return `Logged by ${loggedBy.name.first} ${loggedBy.name.last}`
}
